import Box, { BoxProps } from "@mui/material/Box"
import { observer } from "mobx-react-lite"

// Use flex to make content align to the right (like a float: right)
export default observer(function FlexAlignRight({ sx, children }: Pick<BoxProps, 'sx' | 'children'>) {
   return <Box sx={{ display: 'flex', ...sx }}>
      <Box sx={{ flex: 1 }} />
      <Box children={children} />
   </Box>
})
